import { string, object } from 'yup';

export const validationSchema = object().shape({
  homeId: string().nullable().required('Home is required'),
  ownerId: string().nullable().required('Staff member is required'),
});
